import { ComponentClass, PropsWithoutRef, RefAttributes } from "react";
import { Modal as BulmaModal, ModalProps } from "react-bulma-components";

import styled from "styled-components";

const ModalCard = styled(BulmaModal.Card)<{ $bigCard: boolean }>`
  &&& {
    background: white;
    border-radius: 6px;
    padding: 0px 48px;

    ${props =>
      props.$bigCard && `width: 80vw !important; height: 90vh !important;`};

    @media (max-width: 600px) {
      padding: 0px 24px;
    }
  }
`;

const ModalCardTitle = styled(BulmaModal.Card.Title)`
  &&& {
    color: #22354b;
    font-size: 24px;

    @media (max-width: 600px) {
      font-size: 20px;
    }
  }
`;

const ModalCardHeader = styled(BulmaModal.Card.Head)`
  &&& {
    background: white;
    padding: 48px 0 24px;
    font-weight: 600;

    @media (max-width: 600px) {
      padding: 24px 0 16px;
    }

    .delete {
      position: absolute;
      background: transparent;
      top: 16px;
      right: -32px;

      @media (max-width: 600px) {
        right: -16px;
      }

      &::after {
        height: 100%;
        background-color: black;
      }

      &::before {
        width: 100%;
        background-color: black;
      }
    }
  }
`;

const ModalCardBody = styled(BulmaModal.Card.Body)`
  &&& {
    background: white;
    padding: 0;
  }
`;

const ModalCardFooter = styled(BulmaModal.Card.Foot)`
  &&& {
    background: white;
    border-top: none;
    flex-direction: column;
    justify-content: flex-end;
    padding: 32px 0 48px;

    @media (max-width: 600px) {
      padding: 16px 0 24px;
    }

    button {
      width: 100%;
    }

    > button:not(:last-child) {
      margin-right: 0;
      margin-left: 0;
    }
  }
`;

export class Modal extends (BulmaModal as unknown as ComponentClass<
  PropsWithoutRef<ModalProps> & RefAttributes<"div">
>) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static Card: any;
}

Modal.Card = ModalCard;
Modal.Card.Title = ModalCardTitle;
Modal.Card.Head = ModalCardHeader;
Modal.Card.Body = ModalCardBody;
Modal.Card.Foot = ModalCardFooter;
